import type { ReactNode } from "react";

export type Tone = "neutral" | "green" | "amber" | "orange" | "blue" | "grey" | "outline";

export function Badge({ tone = "neutral", dot = false, children }: { tone?: Tone; dot?: boolean; children: ReactNode }) {
  return (
    <span className={`badge badge-${tone}`}>
      {dot ? <span className="badge-dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
